import { initProducts, updateProducts } from 'reactApp/modules/products/products.module';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { store } from 'reactApp/store';
import type { Product, Tariff } from 'reactApp/types/Billing';

class ProductsController {
    public loadProducts = (): Promise<void> => {
        if (ProductsSelectors.getLifeCycleState(store.getState()).isLoaded) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            store.dispatch(
                initProducts({
                    onSuccess: resolve,
                    onError: reject,
                })
            );
        });
    };

    public updateProducts = (productId?: string, usePing: boolean = true): Promise<Product | undefined> =>
        new Promise((resolve, reject) => {
            store.dispatch(
                updateProducts({
                    productId,
                    usePing,
                    onSuccess: resolve,
                    onError: reject,
                })
            );
        });

    public getAvailableProducts = async (): Promise<Tariff[]> => {
        try {
            await this.loadProducts();

            return ProductsSelectors.getAvailableProducts(store.getState());
        } catch (error) {
            return [];
        }
    };
}

const productsController = new ProductsController();

export { productsController, ProductsController };
